import { useState } from "react";
import { useQuery } from "react-query";
import ListPage from "./List";
import FormPage from "./Form";
import { getAll as getProfiles } from "../../../services/profiles.service";

export default function UsersPage(props: any) {
  const [profiles, setProfiles] = useState<any[]>([]);

  useQuery(
    ["loadProfiles"],
    () => getProfiles(),
    {
      onSuccess: (response) => setProfiles(response.data),
      refetchOnWindowFocus: false,
    }
  );

  return (
    <div className="content_page">
      {(!props.action || props.action == "list") && (
        <ListPage profiles={profiles} />
      )}

      {props.action && ["create", "edit"].includes(props.action) && (
        <FormPage action={props.action} profiles={profiles} />
      )}
    </div>
  );
}
